import { WorkOrderHistory } from "components/QueueBoard/models/workOrderTypes";
import {
  EntityTypeEnum,
  ActivityTypeEnum,
} from "./enums/workOrderActivity.enums";

export function getActivityAction(history: WorkOrderHistory): string {
  const isSegComment = history.relatedEntity === EntityTypeEnum.SegComment;
  const isSegItems = history.relatedEntity === EntityTypeEnum.SegItems;
  const isSegLabor = history.relatedEntity === EntityTypeEnum.SegLabor;

  if (history.activityType === ActivityTypeEnum.INSERT && isSegComment) {
    return "left a Comment on";
  }

  if (history.activityType === ActivityTypeEnum.INSERT && isSegItems) {
    return "added";
  }

  if (history.activityType === ActivityTypeEnum.UPDATE && isSegComment) {
    return "updated a Comment on";
  }

  if (isSegLabor && history.changedFields) {
    try {
      //
      const changes = JSON.parse(history.changedFields);
      const wp = changes.WorkInProgress || {};
      const timeOn = wp.TimeOn?.new;
      const timeOff = wp.TimeOff?.new;

      if (history.activityType === ActivityTypeEnum.INSERT) {
        if (timeOn && timeOff) return "clocked on and off";
        if (timeOn) return "clocked on";
      }

      if (history.activityType === ActivityTypeEnum.UPDATE && timeOff) {
        return "clocked off";
      }
    } catch (err) {
      console.error("Failed to parse changes:", err);
    }
  }

  switch (history.activityType) {
    case ActivityTypeEnum.INSERT:
      return "created";
    case ActivityTypeEnum.UPDATE:
      return "updated";
    case ActivityTypeEnum.DELETE:
      return "deleted";
    default:
      return "performed an action";
  }
}
